(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7447],{

/***/ 19727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ BsCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BsCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 21391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FaAngleDoubleDown; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaAngleDoubleDown(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 320 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 20303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FaChevronRight; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaChevronRight(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 320 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 9633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ SiTrustpilot; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function SiTrustpilot(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "role": "img",
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "title",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.227 16.67l2.19 6.742-7.413-5.388 5.223-1.354zM24 9.31h-9.165L12.005.589l-2.84 8.723L0 9.3l7.422 5.397-2.84 8.714 7.422-5.388 4.583-3.326L24 9.311z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 49011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Icon_fa_FaChevronRight__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20303);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["items"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* ********** */





var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  // ******
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "text-center lg:text-left",
      children: items.map(function (item, itemIdx) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "inline",
          children: itemIdx < items.length - 1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: [itemIdx > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: "mx-3 align-top",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Icon_fa_FaChevronRight__WEBPACK_IMPORTED_MODULE_1__/* .FaChevronRight */ .D, {
                className: "inline text-xs"
              })
            }), item.uri && item.uri.trim().length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: item.uri,
              className: "text-sm font-medium capitalize hover:text-bbc-secondary-100 lg:text-lg",
              children: item.title
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: "text-sm font-medium capitalize lg:text-lg",
              children: item.title
            })]
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: "mx-3 align-top",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Icon_fa_FaChevronRight__WEBPACK_IMPORTED_MODULE_1__/* .FaChevronRight */ .D, {
                className: "inline text-xs"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: "text-sm font-medium capitalize lg:text-lg",
              dangerouslySetInnerHTML: {
                __html: item.title
              }
            })]
          })
        }, itemIdx);
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb);
Breadcrumb.defaultProps = {
  items: []
};

/***/ }),

/***/ 47447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_Banner; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/molecules/Breadcrumb/index.js
var Breadcrumb = __webpack_require__(49011);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(49604);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/FormApplyCompany/index.js




/* ********** */




var FormApplyCompany = function FormApplyCompany(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(data[0]),
      country = _useState[0],
      setCountry = _useState[1];

  var _useState2 = (0,react.useState)(""),
      companyName = _useState2[0],
      setCompanyName = _useState2[1];

  var handleInput = function handleInput(event) {
    setCompanyName(event.target.value);
  };

  var handleSubmit = function handleSubmit() {
    window.location.href = "/onboarding/register?country_id=".concat(country.id, "&company_name=").concat(companyName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col justify-between rounded-full py-1 pr-1 text-sm xl:h-[50px] xl:flex-row xl:bg-white",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-grow lg:min-w-[260px]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-4 w-full whitespace-nowrap rounded-full bg-white xl:mb-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
          value: country,
          onChange: function onChange(value) {
            setCountry(value);
          },
          children: function children(_ref2) {
            var open = _ref2.open;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative text-left ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                as: "div",
                role: "button",
                className: "relative w-full cursor-pointer rounded-full bg-white py-2 px-6 pr-10 text-left text-bbc-gray focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center gap-x-1",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/flags/1x1/".concat(country.country_code.toLowerCase(), ".svg"),
                    width: 24,
                    height: 24,
                    className: "min-h-[24px] min-w-[24px] rounded-full",
                    alt: country.country_code.toLowerCase()
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "truncate",
                    children: country.name
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pointer-events-none absolute inset-y-0 right-1 flex items-center pr-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                    size: 20,
                    className: "absolute right-3  float-right transform align-middle text-bbc-brand-500  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                    "aria-hidden": "true"
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                as: react.Fragment,
                leave: "transition ease-in duration-100",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                  className: "absolute mt-3 max-h-60 w-full overflow-auto rounded-2xl bg-white  text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "overflow-hidden rounded-xl shadow-md",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "max-h-40 overflow-y-auto bg-white text-sm",
                      children: data.map(function (item, itemIdx) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                          className: "list-none",
                          value: item,
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "flex cursor-pointer items-center gap-x-1 px-4 py-2 ".concat(country.id === item.id ? "bg-bbc-primary text-white" : "hover:bg-bbc-primary hover:bg-opacity-40"),
                            onClick: function onClick() {
                              return setCountry(item);
                            },
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                              src: "/assets/flags/1x1/".concat(item.country_code.toLowerCase(), ".svg"),
                              width: 24,
                              height: 24,
                              className: "min-h-[24px] min-w-[24px] rounded-full",
                              alt: item.country_code.toLowerCase()
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              className: "truncate",
                              children: item.name
                            })]
                          })
                        }, itemIdx);
                      })
                    })
                  })
                })
              })]
            });
          }
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden items-center xl:flex",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-6 w-[1px] rounded-full bg-slate-300"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex w-full flex-grow items-center xl:max-w-[190px]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        id: "ipt-company-name",
        placeholder: "Your company name",
        className: "mb-4 w-full truncate rounded-full bg-white px-2 py-2 outline-none xl:mb-0",
        value: companyName,
        onChange: handleInput
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: function onClick() {
          return handleSubmit();
        },
        className: "h-full w-full truncate rounded-full bg-bbc-primary py-2 px-4 text-base text-white lg:text-sm xl:text-base",
        children: "Apply Your Company"
      })
    })]
  });
};

/* harmony default export */ var molecules_FormApplyCompany = (FormApplyCompany);
FormApplyCompany.defaultProps = {};
// EXTERNAL MODULE: ./components/atoms/Icon/bs/BsCheck.js
var BsCheck = __webpack_require__(19727);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaAngleDoubleDown.js
var FaAngleDoubleDown = __webpack_require__(21391);
// EXTERNAL MODULE: ./components/atoms/Icon/si/SiTrustpilot.js
var SiTrustpilot = __webpack_require__(9633);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
;// CONCATENATED MODULE: ./components/molecules/Trustpilot/index.js
/* eslint-disable capitalized-comments */





/* ********** */
// eslint-disable-next-line no-unused-vars





var Trustpilot = function Trustpilot(_ref) {
  var dataDefault = _ref.dataDefault,
      dataTrustpilot = _ref.dataTrustpilot;

  var _useState = (0,react.useState)(false),
      isLinkHover = _useState[0],
      setIsLinkHover = _useState[1]; // const [dataTrustpilotFetch, setDataTrustpilotFetch] = useState(dataDefault);
  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/trustpilot`
  //     )
  //     .then((result) => setDataTrustpilotFetch(result?.data))
  //     .catch((e) => console.error(e));
  // }, []);
  // const { data } = dataTrustpilotFetch;
  // ******


  return dataTrustpilot ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row flex-col lg:flex-row",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center border-bbc-brand-800 lg:col-auto  lg:items-start",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-2 text-bbc-30px font-semibold capitalize text-bbc-brand-800",
        children: "Excellent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "mb-2 font-normal text-bbc-brand-800",
        children: ["Based on ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "inline-block w-7 text-center",
          children: "433"
        }), " ", "reviews"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-1 flex items-center gap-x-[5px]",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex h-7 w-7 items-center justify-center bg-[#21B250]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
            className: "text-xl text-white"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex h-7 w-7 items-center justify-center bg-[#21B250]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
            className: "text-xl text-white"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex h-7 w-7 items-center justify-center bg-[#21B250]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
            className: "text-xl text-white"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex h-7 w-7 items-center justify-center bg-[#21B250]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
            className: "text-xl text-white"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex h-7 w-7 items-center justify-center bg-[#21B250]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
            className: "text-xl text-white"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-end gap-x-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
          className: "mb-1 text-4xl text-[#00B67A]"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-2xl font-semibold text-bbc-brand-800",
          children: "Trustpilot"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-auto hidden items-center lg:flex",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " bg-slate-600",
        style: {
          width: "1px",
          height: "144px"
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-4 flex flex-col items-center justify-center lg:col-7 lg:mt-0 lg:items-start",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: dataTrustpilot.content.benefits && dataTrustpilot.content.benefits.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-2 flex items-start gap-x-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-1.5 rounded-full bg-[#21B250] p-[1px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BsCheck/* BsCheck */.o, {
                className: "text-xs text-white"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "font-medium text-bbc-brand-800",
              children: item
            })]
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [dataTrustpilot.content.button_placeholder && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-2 pt-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            className: "block rounded-full bg-bbc-primary py-2 px-6 font-medium text-white",
            href: dataTrustpilot.content.link_button_placeholder,
            rel: dataTrustpilot.content.rel_placeholder,
            target: dataTrustpilot.content.target_placeholder,
            children: dataTrustpilot.content.button_placeholder
          })
        }), dataTrustpilot.content.see_package && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "group flex items-center gap-x-2 pr-4",
          onMouseEnter: function onMouseEnter() {
            return setIsLinkHover(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setIsLinkHover(false);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaAngleDoubleDown/* FaAngleDoubleDown */.v, {
            className: "text-base text-bbc-primary transition-all group-hover:animate-bounce"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "cursor-pointer",
              onClick: function onClick(e) {
                var scrollToTable = document.querySelectorAll("[id ^= \"".concat(dataTrustpilot.content.see_package_id, "\"]"));
                scrollToTable.forEach(function (el) {
                  return window.scrollTo({
                    top: el.getBoundingClientRect().top - 110,
                    behavior: "smooth"
                  });
                });
                e.preventDefault();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "font-medium text-bbc-primary",
                children: dataTrustpilot.content.see_package || ""
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "absolute h-0.5 w-full origin-left scale-x-0 bg-bbc-primary group-hover:scale-x-100".concat(isLinkHover ? " transition-transform duration-300" : "")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "absolute h-0.5 w-full origin-right scale-x-0 bg-bbc-primary delay-200 duration-200 group-hover:scale-x-100".concat(isLinkHover ? "" : " transition-transform duration-300")
            })]
          })]
        })]
      })]
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

/* harmony default export */ var molecules_Trustpilot = (Trustpilot);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/ai/AiOutlineUser.js

function AiOutlineUser(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
      }
    }]
  })(props);
}
;
;// CONCATENATED MODULE: ./components/atoms/Icon/fi/FiBookOpen.js

function FiBookOpen(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
      }
    }]
  })(props);
}
;
;// CONCATENATED MODULE: ./components/atoms/Icon/md/MdAccessTime.js

function MdAccessTime(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
      }
    }]
  })(props);
}
;
;// CONCATENATED MODULE: ./components/organisms/Banner/PostMeta/index.js



/* ********** */




var PostMeta = function PostMeta(_ref) {
  var author = _ref.author,
      timeRead = _ref.timeRead,
      date = _ref.date,
      textProps = _ref.textProps,
      iconProps = _ref.iconProps;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-wrap items-center justify-center gap-x-6 gap-y-3 lg:justify-start",
    children: [author && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "hidden items-center gap-x-2 lg:flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AiOutlineUser, {
        className: iconProps.className ? iconProps.className : "text-xl"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: textProps.className ? textProps.className : "text-sm italic",
        children: author
      })]
    }), timeRead && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "ml-1 flex items-center gap-x-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiBookOpen, {
        className: iconProps.className ? iconProps.className : "text-xl"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: textProps.className ? textProps.className : "text-sm italic",
        children: timeRead
      })]
    }), date && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center gap-x-1.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MdAccessTime, {
        className: iconProps.className ? iconProps.className : "text-xl"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: textProps.className ? textProps.className : "text-sm italic",
        children: date
      })]
    })]
  });
};

/* harmony default export */ var Banner_PostMeta = (PostMeta);
PostMeta.defaultProps = {
  author: null,
  timeRead: null,
  date: null,
  textProps: {},
  iconProps: {}
};
// EXTERNAL MODULE: ./components/organisms/Banner/Index.module.scss
var Index_module = __webpack_require__(95058);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
;// CONCATENATED MODULE: ./components/organisms/Banner/index.js


var _excluded = ["children", "breadcrumbs", "bgColor", "bgStyle", "tag", "title", "description", "author", "timeRead", "date", "leftContent", "rightContent", "titleProps", "descriptionProps", "dataTrustpilot", "isApplyCompanyForm", "leftClassName", "rightClassName", "wave", "minHeightBanner", "breadcrumbMarginClass"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Banner = function Banner(_ref) {
  var children = _ref.children,
      breadcrumbs = _ref.breadcrumbs,
      bgColor = _ref.bgColor,
      bgStyle = _ref.bgStyle,
      tag = _ref.tag,
      title = _ref.title,
      description = _ref.description,
      author = _ref.author,
      timeRead = _ref.timeRead,
      date = _ref.date,
      leftContent = _ref.leftContent,
      rightContent = _ref.rightContent,
      titleProps = _ref.titleProps,
      descriptionProps = _ref.descriptionProps,
      dataTrustpilot = _ref.dataTrustpilot,
      isApplyCompanyForm = _ref.isApplyCompanyForm,
      leftClassName = _ref.leftClassName,
      rightClassName = _ref.rightClassName,
      wave = _ref.wave,
      minHeightBanner = _ref.minHeightBanner,
      breadcrumbMarginClass = _ref.breadcrumbMarginClass,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((Index_module_default()).wrapperBanner, " relative mt-[68px] overflow-hidden lg:mt-[38px]"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute left-0 top-0 h-full w-full p-0 ".concat(bgColor),
      style: bgStyle ? bgStyle : {}
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
      className: "".concat(minHeightBanner ? minHeightBanner : "banner-min-h-635", " relative lg:pt-[66px]")
    }, props.bannerCustom), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex-shrink flex-grow pt-6 lg:pt-[70px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row  justify-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat(leftClassName, " z-20"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [Array.isArray(breadcrumbs) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat(breadcrumbMarginClass ? breadcrumbMarginClass : "mb-6 lg:mb-10"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                    items: breadcrumbs
                  })
                }), tag && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-2 text-center italic lg:text-left",
                  children: tag
                }), title && typeof title === "string" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-6 lg:mb-8",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                    className: titleProps !== null && titleProps !== void 0 && titleProps.className ? (titleProps === null || titleProps === void 0 ? void 0 : titleProps.className) + (titleProps !== null && titleProps !== void 0 && titleProps.textColor ? " ".concat(titleProps === null || titleProps === void 0 ? void 0 : titleProps.textColor) : "") : "text-center text-4xl font-semibold leading-[58px] lg:text-left lg:text-bbc-48px ".concat(titleProps !== null && titleProps !== void 0 && titleProps.textColor ? " ".concat(titleProps === null || titleProps === void 0 ? void 0 : titleProps.textColor) : ""),
                    dangerouslySetInnerHTML: {
                      __html: title
                    }
                  })
                }) : title, description && ( /*#__PURE__*/react.isValidElement(description) ? description : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-6 text-center lg:mb-10 lg:text-left",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className,
                    dangerouslySetInnerHTML: {
                      __html: description
                    }
                  })
                })), dataTrustpilot && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: dataTrustpilot.className || "mb-6 lg:mb-8",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Trustpilot, {
                    dataDefault: dataTrustpilot.dataDefault,
                    dataTrustpilot: dataTrustpilot.dataStatic
                  })
                }), isApplyCompanyForm && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-10 lg:mb-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_FormApplyCompany, {
                    data: isApplyCompanyForm
                  })
                }), !author && !timeRead && !date ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-6 lg:mb-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner_PostMeta, {
                    author: author,
                    timeRead: timeRead,
                    date: date
                  })
                })]
              }), leftContent]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: rightClassName,
              children: rightContent
            }), children && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12",
              children: children
            })]
          })
        })
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: wave
    })]
  });
};

/* harmony default export */ var organisms_Banner = (Banner);
Banner.defaultProps = {
  breadcrumbs: null,
  tag: null,
  title: null,
  description: null,
  author: null,
  timeRead: null,
  date: null,
  leftContent: null,
  rightContent: null,
  bgColor: "bg-bbc-gradient-10",
  titleProps: {
    className: "banner-default-title",
    textColor: "banner-title-default-color"
  },
  descriptionProps: {},
  bannerPanelProps: {},
  dataTrustpilot: null,
  isApplyCompanyForm: null,
  minHeightBanner: "banner-min-h-635 ",
  leftClassName: "relative col-12 lg:col-6",
  rightClassName: "relative col-12 lg:col-6"
};

/***/ }),

/***/ 95058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapperBanner":"Index_wrapperBanner__0XbIp"};

/***/ })

}]);